<template>
  <div id="daily-summary">
    <div class="weeklyprogress slide-in-bottom">
      <p>WEEKLY PROGRESS</p>

      <div id="daytracker">
        <div v-for="(day, index) in daysOfWeek" :key="day" class="dayofweek">
          <img v-if="getDayOfWeek > index" src="../assets/ic_day_check@2x.png" />
          <img v-if="getDayOfWeek <= index" src="../assets/ic_day_upcoming@2x.png" />
          <p>{{ day }}</p>
        </div>
      </div>
    </div>

    <div class="sparks slide-in-bottom">
      <div>
        <img src="../assets/ic_quotation@2x.png" />
        <div class="sparktext">
          <!-- <h3>RESILIENCE</h3>
          <p>
            Happiness is not the absence of problems, it’s the ability to deal with them.
            <br />
            <br />
            <em>― Steve Maraboli, Life, the Truth, and Being Free</em>
          </p>-->
          <!-- <h3>MINDSET</h3>
          <p>
            คนที่ปิดกั้นตัวเอง มีความเชื่อว่าพวกเขาเกิดมาพร้อมกับความสามารถบางอย่าง แต่ไม่สามารถที่จะพัฒนาไปเก่งในเรื่องอื่นๆ ได้ ส่วนคนที่เปิดกว้างที่จะเรียนรู้ มักมีความเชื่อว่าพวกเขาสามารถที่จะเก่งในเรื่องใดก็ได้ หากมีความพยายามที่มากพอ
            <br />
            <br />mindset แบบไหนที่คุณเป็น?
            <br />
            <br />เร็วๆ นี้ เราจะพาคุณไปเปิดโลกของ Mindset โดย Carol Dweck อาจารย์และนักเขียนด้านจิตวิทยาคนดัง เพื่อทำความเข้าใจกันว่าทำไม growth mindset จึงเป็นสิ่งที่ดีงาม
          </p>-->
          <h3>HELP YOUR MANAGERS</h3>
          <p v-if="lang == 'th'">
            หัวหน้า คือคนที่อยู่ในตำแหน่งที่จะหยิบยื่นความช่วยเหลือให้คุณได้ดีที่สุด ลองแบ่งปันความคิดเห็นและพูดคุยกัน ให้ทั้งสองฝ่ายได้เรียนรู้กันและเข้าใจกันมากขึ้น
            <br />
            <br />อย่าลืมว่าหัวหน้าก็คือมนุษย์คนหนึ่ง ซึ่งคนเหล่านี้ก็มีปัญหาและความท้าทายที่เขาต้องเจอเช่นกัน บางทีการให้กำลังใจพวกเขาบ้างก็ไม่เลวนะ!
          </p>
          <p v-else>
            Your managers are in the best position to help you. As you share feedback, help them help you!
            <br />
            <br />Remember that your managers are just people with their own problems and challenges too. It helps to give them encouragement!
          </p>
        </div>

        <div @click.prevent="handleVote()" class="starbutton">
          <img :class="anim.pulse == true ? 'heartbeat' : ''" src="../assets/ic_star_small@2x.png" />
          <p>{{ numberWithCommas(spark.votes) }}</p>
        </div>
      </div>
    </div>

    <div class="sessionhighlights slide-in-bottom">
      <p>SESSION HIGHLIGHTS</p>

      <div class="activityrow slide-in-bottom delay-0-5">
        <img src="../assets/ic_coin@2x.png" />
        <p>
          You’ve collected
          <strong>+{{ status.coinsadded }} coins</strong>
        </p>
      </div>
      <div class="activityrow slide-in-bottom delay-1-0">
        <img src="../assets/ic_xp@2x.png" />
        <p>
          You collected
          <strong>+20 XP</strong> for your house
        </p>
      </div>
      <div class="activityrow slide-in-bottom delay-1-5">
        <img src="../assets/ic_streak@2x.png" />
        <p>
          You’re on a
          <strong>57 day</strong> streak!
        </p>
      </div>
      <div v-show="status.feedback" class="activityrow slide-in-bottom delay-2-0">
        <img src="../assets/ic_feedback@2x.png" />
        <p>
          You’ve contributed feedback
          <strong>40 times</strong>!
        </p>
      </div>
    </div>

    <a href="https://happily.ai/th" class="actionbutton">MORE ABOUT HAPPILY</a>
  </div>
</template>

<script>
export default {
  name: "daily-summary",
  props: {
    status: Object,
  },
  created(){
    var currentUrl = window.location.pathname;
    if (currentUrl == '/en') {
      this.lang = 'en';
    }
  },
  data() {
    return {
      lang: 'th',
      spark: {
        type: "",
        votes: 2674
      },
      anim: {
        pulse: false
      },
      daysOfWeek: ["M", "T", "W", "Th", "F"],
    };
  },
  methods: {
    handleVote() {
      this.spark.votes = this.spark.votes + 1;
      this.anim.pulse = true;

      var self = this;

      setTimeout(function() {
        self.anim.pulse = false;
      }, 1000);
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  },
  computed: {
    getDayOfWeek() {
      var d = new Date();
      var n = d.getDay();
      console.log("Day of Week: " + n);
      return n;
    }
  }
};
</script>

<style scoped>
#daily-summary {
  background: #121740;
  background: linear-gradient(36deg, #121740 10%, #6b3093 100%);
  font-family: "Lato";
  bottom: 0;
  color: white;
  display: block;
  font-size: 32px;
  left: 0;
  overflow: scroll;
  position: fixed;
  right: 0;
  top: 0;
  text-align: center;
}
.weeklyprogress,
.sparks,
.sessionhighlights {
  background: rgba(0, 0, 0, 0.23);
  border-radius: 6px;
  display: block;
  width: 93%;
  margin: 0 auto;
}
.weeklyprogress p,
.sessionhighlights p {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.6);
  padding-top: 24px;
}
.weeklyprogress {
  margin-top: 80px;
}
.dayofweek {
  display: inline-block;
  margin: 12px 20px 24px 0;
}
.dayofweek:last-child {
  margin: 0;
}
.dayofweek img {
  width: 32px;
  height: 32px;
}
.dayofweek p {
  margin: 0;
  padding: 0;
}
.sparks {
  margin-top: 12px;
  text-align: left;
  padding: 24px 0 24px 0;
}
.sparks img,
.sparks .sparktext {
  display: inline-block;
  vertical-align: top;
}
.sparks img {
  width: 36px;
  height: 36px;
  margin: 0 0 0 16px;
}
.sparktext {
  width: 74%;
  margin: 0 0 0 16px;
}
.sparks h3 {
  font-size: 12px;
  margin: 0;
  padding: 0;
}
.sparks p {
  font-size: 14px;
  margin: 4px 0 0 0;
  font-family: "Kanit";
}
.starbutton {
  text-align: center;
  margin: 12px 0 0 0;
}
.starbutton img,
.starbutton p {
  display: inline-block;
  vertical-align: middle;
}
.starbutton img {
  width: 22px;
  height: 22px;
}
.starbutton p {
  font-weight: 600;
  margin: 0 0 0 6px;
  font-size: 13px;
}
.sessionhighlights {
  padding-bottom: 24px;
  margin-bottom: 80px;
}
.activityrow {
  text-align: left;
}
.activityrow img {
  width: 22px;
  height: 22px;
  display: inline-block;
  vertical-align: middle;
  margin: 0 0 0 24px;
}
.activityrow p {
  display: inline-block;
  color: #ffffff;
  padding: 0 16px 0 12px;
  vertical-align: middle;
  font-size: 14px;
}
.actionbutton {
  background: #00bcd4;
  height: 50px;
  width: 90%;
  font-size: 16px;
  font-weight: 900;
  line-height: 50px;
  border-radius: 6px;
  position: fixed;
  bottom: 24px;
  left: 5%;
  box-shadow: 0 3px 0px rgb(2, 49, 55);
  color: #ffffff;
  text-decoration: none;
}
.actionbutton:active {
  background: rgb(0, 131, 148);
}
.slide-in-bottom {
  animation: slide-in-bottom 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}
.delay-0-5 {
  animation-delay: 0.5s;
}
.delay-1-0 {
  animation-delay: 1s;
}
.delay-1-5 {
  animation-delay: 1.5s;
}
.delay-2-0 {
  animation-delay: 2s;
}
.heartbeat {
  -webkit-animation: heartbeat 1.5s ease-in-out infinite both;
  animation: heartbeat 1.5s ease-in-out infinite both;
}
/* ----------------------------------------------
 * Generated by Animista on 2019-8-3 13:50:7
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

@keyframes slide-in-bottom {
  0% {
    transform: translateY(1000px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
/* ----------------------------------------------
 * Generated by Animista on 2019-8-3 17:24:24
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

@-webkit-keyframes heartbeat {
  from {
    -webkit-transform: scale(2);
    transform: scale(2);
    -webkit-transform-origin: center center;
    transform-origin: center center;
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
  10% {
    -webkit-transform: scale(0.2);
    transform: scale(0.2);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  17% {
    -webkit-transform: scale(2);
    transform: scale(2);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
  33% {
    -webkit-transform: scale(2);
    transform: scale(2);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  45% {
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
}
@keyframes heartbeat {
  from {
    -webkit-transform: scale(2);
    transform: scale(2);
    -webkit-transform-origin: center center;
    transform-origin: center center;
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
  10% {
    -webkit-transform: scale(1.6);
    transform: scale(1.6);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  17% {
    -webkit-transform: scale(2);
    transform: scale(2);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
  33% {
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-animation-timing-function: ease-in;
    animation-timing-function: ease-in;
  }
  45% {
    -webkit-transform: scale(1);
    transform: scale(1);
    -webkit-animation-timing-function: ease-out;
    animation-timing-function: ease-out;
  }
}
</style>